import axios from 'Services/axios';

import type {
	GetSellerCommunicationTemplateReturn,
	PatchRequest,
	PatchSellerCommunicationTemplateReturn,
	PostRequest,
	PostSellerCommunicationTemplateReturn,
} from './request';

export type GetSellerCommunicationTemplateClientApiCall = () => GetSellerCommunicationTemplateReturn;

const SELLER_COMMUNICATIONS_TEMPLATE_CLIENT_PATH = `/api/seller-communications/template`;

export const getSellerCommunicationTemplate: GetSellerCommunicationTemplateClientApiCall = async () => {
	const res = await axios.get(SELLER_COMMUNICATIONS_TEMPLATE_CLIENT_PATH);
	return res.data as ReturnType<GetSellerCommunicationTemplateClientApiCall>;
};

export type PostSellerCommunicationTemplateClientApiCall = (
	data: PostRequest['body'],
) => PostSellerCommunicationTemplateReturn;

export const postSellerCommunicationTemplate: PostSellerCommunicationTemplateClientApiCall = async (data) => {
	const res = await axios.post(SELLER_COMMUNICATIONS_TEMPLATE_CLIENT_PATH, data);
	return res.data as ReturnType<PostSellerCommunicationTemplateClientApiCall>;
};

export type PatchSellerCommunicationTemplateClientApiCall = (
	data: PatchRequest['body'],
) => PatchSellerCommunicationTemplateReturn;

export const patchSellerCommunicationTemplate: PatchSellerCommunicationTemplateClientApiCall = async (data) => {
	const res = await axios.patch(SELLER_COMMUNICATIONS_TEMPLATE_CLIENT_PATH, data);
	return res.data as ReturnType<PatchSellerCommunicationTemplateClientApiCall>;
};
